/**
 * @fileoverview Input/output schemas for chapter-planner-v2.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { ChapterIdeaSchema } from '@/domains/chapter-workspace/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.seriesContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterMetadata.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.actualLastThreeChaptersContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.charactersCurrent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.planningGenreGuidance.schema.shape,
  isReplan: z.boolean().optional().describe('When true, the agent replans an existing chapter instead of planning a new one.'),
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  suggestion: ChapterIdeaSchema.describe('The single suggested next chapter for the story.'),
});

export type Output = z.infer<typeof OutputSchema>;
